import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 30px;
	height: 800px;

	transition: opacity 0.25s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

const StyledWarningContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr 30px;
	align-items: center;
	column-gap: 20px;
	row-gap: 10px;
	height: 140px;
	padding: 0 40px;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.02);
	pointer-events: none;
`;

const StyledWarningDots = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-left: 20px;

	.dot {
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: rgba(255, 255, 255, 0.1);

		&:nth-child(2) {
			background-color: #ffffff;
		}
	}
`;

const StyledSectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledStatsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
`;

const StyledExpensesContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 29px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	min-height: 180px;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledExpensesBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
	margin-top: auto;

	img {
		opacity: 0.5;
	}
`;

const StyledStatsAmountContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPenaltiesContainer = styled.div`
	// display: flex;
	flex-direction: column;
	row-gap: 23px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	// в данной итерации скрыто
	display: none;
`;

const StyledPenaltiesHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPenaltiesBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding: 35px 30px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledInfoRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-size: 16px;
		color: #ffffff;

		&:nth-child(2n + 1) {
			opacity: 0.25;
		}

		&:nth-child(2n) {
			font-size: 500;
		}
	}
`;

const StyledUpgradeButton = styled.button`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 60px;
	border-radius: 10px;
	border: 1px solid rgba(255, 229, 0, 0);
	background: radial-gradient(
			107.5% 107.5% at 50% 100%,
			rgba(255, 229, 0, 0.5) 0%,
			rgba(255, 229, 0, 0) 100%
		),
		#da9d00;

	color: #000;
	text-align: center;
	font-family: GT Walsheim Pro;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	cursor: pointer;
	transition: background 0.3s ease;

	&:hover {
		background: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledExpensesBottomContainer,
	StyledExpensesContainer,
	StyledInfoContainer,
	StyledInfoRow,
	StyledPenaltiesBottomContainer,
	StyledPenaltiesContainer,
	StyledPenaltiesHeadingContainer,
	StyledSectionContainer,
	StyledStatsAmountContainer,
	StyledStatsContainer,
	StyledUpgradeButton,
	StyledWarningContainer,
	StyledWarningDots,
};
